<template lang="pug">
    .mobile 暂不支持移动端，请从PC端访问 {{href}}
</template>

<script>
import isMobile from 'is-mobile';
export default {
    name: 'Mobile',
    data() {
        return {};
    },
    created() {},
    mounted() {
        if (!isMobile()) this.$router.push('/');
    },
    computed: {
        href() {
            return window.location.href
                .replace(/\#.+\??/, '?')
                .replace(/\?$/, '');
        },
    },
};
</script>

<style lang="stylus" scoped>
.mobile
    position absolute
    left 0
    top 0
    width 100vw
    height 100vh
    display flex
    align-items center
    justify-content center
    text-align center
</style>
